module.exports = __webpack_public_path__ + "img/lv.9fa6c690.svg";